import React from 'react';
import FourOhFour from 'components/UI/404';
import { withRouter } from 'utils/withRouter';
import * as Sentry from '@sentry/react';
import { connect } from 'react-redux';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    componentDidMount() {
        const { history } = this.props;

        this.unlisten = history.listen((location, action) => {
            if (this.state.hasError) {
                this.setState({
                    hasError: false,
                    error: null,
                    errorInfo: null,
                });
            }
        });
    }

    componentWillUnmount() {
        this.unlisten();
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Store error details in state for Sentry reporting
        this.setState({
            error: error,
            errorInfo: errorInfo,
        });

        // Report to Sentry with additional context
        Sentry.withScope((scope) => {
            scope.setTag('errorBoundary', true);
            scope.setContext('errorInfo', {
                componentStack: errorInfo.componentStack,
                errorBoundary: this.constructor.name,
            });
            scope.setLevel('error');

            if (this.props?.auth?.teacher?.id) {
                scope.setUser({
                    id: this.props.auth.teacher.id,
                    tenantId: this.props.auth.teacher.schoolId,
                });
            }

            // Add extra context
            scope.setExtra('errorBoundaryProps', {
                hasChildren: !!this.props.children,
                childrenType: this.props.children?.type?.name || 'Unknown',
            });

            Sentry.captureException(error);
        });
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <FourOhFour error={this.state.error} />;
        }

        return this.props.children;
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps, {})(withRouter(ErrorBoundary));
